import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9909e03e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-column" }
const _hoisted_2 = ["id"]
const _hoisted_3 = {
  key: 0,
  class: "card-header-title"
}

import { computed } from "vue"
import { useStore } from "vuex"
import {EntityType} from "@/interfaces/global";
import InfoWrapper from "@/components/library/content/info/InfoWrapper.vue";
import InfoTags from "@/components/library/content/info/tags/InfoTags.vue";
import WhereUsed from "@/components/library/content/whereused/WhereUsed.vue";
import Related from "@/components/library/content/related/Related.vue";
import Comments from "@/components/library/content/comments/Comments.vue";
import Suggestions from "@/components/library/content/suggestions/Suggestions.vue";
import { useBreakpoints } from "@/helpers"
import { DetailPageComponentTitles } from "@/interfaces/library/detailLayouts";
import i18n from "@/locales";


export default /*#__PURE__*/_defineComponent({
  __name: 'ColumnLayout',
  props: {
  content: {
    type: Object,
    required: true
  },
  columnInfo: {
    type: Object,
    required: true
  }
},
  setup(__props) {

const props = __props
const { width } = useBreakpoints()
const isPart = computed(() => props.content.type === EntityType.part)
const isPage = computed(() => props.content.type === EntityType.page)
const store = useStore()
const canViewComments =  computed(() => store.getters['user/canViewComments'])
const canViewRelated = computed(() => store.getters['user/canViewRelated'])
const canViewWhereUsed = computed(() => isPart.value || isPage.value)
const canViewSuggestions = computed(() => {
  return store.getters['user/hasPartOrderSuggestions'] && isPart.value
})
const isMobileView = computed(() => width.value <= 768)
function castIdToNumber (id: string) {
  return parseInt(id)
}

function componentAvailable (componentName: String): boolean {
  switch (componentName) {
    case 'InfoWrapper':
      return true
      break;
    case 'InfoTags':
      return true
      break;
    case 'WhereUsed':
      return canViewWhereUsed.value
      break;
    case 'Related':
      return canViewRelated.value
      break;
    case 'Comments':
      return canViewComments.value
      break;
    case 'Suggestions':
      return canViewSuggestions.value
    default:
      return false
  }
}

function componentHeight (componentName: String): string {
  if (componentName === 'WhereUsed' && !isMobileView.value) { return '90vh' }
  else { return '60vh'}
}

const componentMap: Record<string, any> = {
  'InfoWrapper': InfoWrapper,
  'InfoTags': InfoTags,
  'WhereUsed': WhereUsed,
  'Related': Related,
  'Comments': Comments,
  'Suggestions': Suggestions
}

const titleMap: Object = {
  'InfoWrapper': '',
  'InfoTags': i18n.global.tc('detail', 2),
  'WhereUsed': i18n.global.t('whereUsed'),
  'Related': i18n.global.t('related'),
  'Comments': i18n.global.tc('comment', 2),
  'Suggestions': i18n.global.tc('suggestion', 2)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columnInfo, (value, key) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
        (componentAvailable(value))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              id: value,
              class: _normalizeClass(["card detail-card column-item", {'where-used-card': value === 'WhereUsed'}])
            }, [
              (titleMap[value] !== '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t(titleMap[value])), 1))
                : _createCommentVNode("", true),
              (_openBlock(), _createBlock(_resolveDynamicComponent(componentMap[value]), {
                id: castIdToNumber(__props.content.id),
                content: __props.content,
                type: __props.content.type,
                showTags: false,
                height: componentHeight(value)
              }, null, 8, ["id", "content", "type", "height"]))
            ], 10, _hoisted_2))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}
}

})